import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
            用户口碑
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">
            追综热议
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            真实观众评价，看看大家都在聊什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-5xl mx-auto">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-5 border border-background-200/70"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-800">
                      {comment.name}
                    </span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-xs text-amber-400"></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes}
                </span>
                <span className="cursor-pointer hover:text-primary-500 transition-colors">
                  回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}